import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from '../../../core/services/validation/validation.service';

import { fieldsMatch } from '../../../core/validators/fields-match.validator';
import { ResetPasswordInterface } from '../reset-password.interface';

const formMapping = Object.freeze({ password: 'password', passwordRepeat: 'passwordRepeat' });

@Component({
  selector: 'app-reset-password-form',
  templateUrl: './reset-password-form.component.html',
  styleUrls: ['./reset-password-form.component.css']
})
export class ResetPasswordFormComponent implements OnInit, OnChanges {
  form: FormGroup;
  @Input() errors: any;
  @Output() reset = new EventEmitter<ResetPasswordInterface>();

  constructor(
    private fb: FormBuilder,
    private validationService: ValidationService
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(16)]],
      passwordRepeat: [
        '',
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(16),
          fieldsMatch('password')
        ]
      ]
    });
  }

  ngOnChanges() {
    this.validationService.showFieldErrors(this.errors, this.form, formMapping);
  }

  onSubmitted() {
    const value = this.form.value;
    const password: ResetPasswordInterface = { password: value.password, passwordRepeat: value.passwordRepeat };
    this.reset.emit(password);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/auth/reset-password/reset-password-form/reset-password-form.component.ts